
import { defineComponent, inject, ref } from 'vue'
import RandselDialog from '@/components/Abstract/RandselDialog.vue'
import CopyLinkService from '@/services/form/copy-link.service'
import { useStore } from '@/store'
import LinkGeneratorService from '@/services/configuration/link-generator.service'
import SentrySingleton from '@/singletons/sentry-singleton'
const QRCode = require('qrcode')

export default defineComponent({
  name: 'CopyLinkDialog',
  components: {
    RandselDialog
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const getShowEventName = ref(determineShowEventName())
    let linkGeneratorService = new LinkGeneratorService()
    let copyLinkService = new CopyLinkService()
    let link = ref('')
    let root = ref<InstanceType<typeof RandselDialog>>()
    let canvas = ref<InstanceType<typeof HTMLCanvasElement>>()

    const onClick = () => {
      copyLinkService.copyLink(link.value)
      closeDialog()
    }

    const onShow = () => {
      try {
        const copyLink = linkGeneratorService.createCopyLink(store.getters.currentConfig, true, store.getters.isRenderingMode)
        link.value = copyLink
        drawQrcode(copyLink)
      } catch (err: any) {
        SentrySingleton.instance.captureException(err)
      }
    }

    async function drawQrcode(copyLink: string) {
      try {
        await getCanvas()
        QRCode.toCanvas(canvas.value, copyLink, { width: 200 }, (error: any) => {
          if (error) {
            SentrySingleton.instance.captureMessage(error)
          } else {
            console.log('successfully created QR code! isMobile: ' + props.isMobile)
          }
        })
      } catch (err: any) {
        SentrySingleton.instance.captureException(err)
      }
    }

    async function getCanvas() {
      return new Promise((resolve, reject) => {
        resolve(canvas.value)
      })
    }

    function closeDialog() {
      root.value?.hideDialog()
    }

    function determineShowEventName() {
      return 'openCopyLinkDialog' + (props.isMobile ? 'mobile' : 'desktop')
    }

    return {
      root,
      canvas,
      getShowEventName,
      onClick,
      onShow,
      link
    }
  }
})
